import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { EventMapResponse, EventResponse } from '../../../types/Event';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type EventFilterKey = 'account' | 'employees' | 'date_range' | 'start_date_range' | 'status' | 'event_type' | 'event_location' | 'contacts' | 'archived';

export type EventFilterParam = {
  [K in EventFilterKey]?: (string | null)[];
};

export type EventSortParam = {
  [K in EventAvailableColumns]?: -1 | 1;
};

export type EventAvailableColumns =
  | 'name'
  | 'status'
  | 'event_template_name'
  | 'type_value'
  | 'location_value'
  | 'start_at'
  | 'end_at'
  | 'date'
  | 'account_name'
  | 'account_code'
  | 'tags';

export type UseGetAllEventsParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: EventFilterParam;
  sort?: EventSortParam;
  list_columns?: EventAvailableColumns[];
};

export type UseGetAllEventsProps = {
  params?: UseGetAllEventsParams;
  enabled?: boolean;
};

export const fetchAllEvents = async ({ params }: UseGetAllEventsProps) => {
  const response = await CustomAxios.get<EventResponse>(`events`, { params });
  const { data } = response;
  return data;
};

export function useGetAllEvents({ params, enabled = true }: UseGetAllEventsProps) {
  const queryKey: any = [queryKeys.allEvents, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllEvents({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}

// Map Events
export const fetchEventMap = async ({ params }: UseGetAllEventsProps) => {
  const response = await CustomAxios.get<EventMapResponse>('events.map', { params });
  return response.data;
};
export function useGetEventMap({ params, enabled = true }: UseGetAllEventsProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.eventMap, params],
    queryFn: () => fetchEventMap({ params }),
    placeholderData: keepPreviousData,
  });
}
